var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnChanges } from '@angular/core';
import { MdrService } from '../../../providers/mdr.service';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar, MatTableDataSource } from '@angular/material';
import { DrService } from '../../../providers/dr.service';
import { HttpClient } from '@angular/common/http';
import { DrObservable } from '../../../services/dr.service';
import { MdrObservable } from '../../../services/mdr.service';
import { Legs, Pin } from '../../../models/legs';
import { MDR } from '../../../models/mdr';
var GeolocationComponent = /** @class */ (function () {
    function GeolocationComponent(drService, mdrService, aRoute, http, drObservable, mdrObservable, snackBar) {
        this.drService = drService;
        this.mdrService = mdrService;
        this.aRoute = aRoute;
        this.http = http;
        this.drObservable = drObservable;
        this.mdrObservable = mdrObservable;
        this.snackBar = snackBar;
        this.lat = -16.520536;
        this.lng = -68.194289;
        this.latNew = -16.520536;
        this.lngNew = -68.194289;
        this.distanceByLeg = [];
        this.i = 0;
        this.typeTransp = [{ name: 'Rodoviário', value: 0 }, { name: 'Balsa', value: 1 }, { name: 'Transporte Aéreo', value: 2 }];
        this.renderOptions = {
            suppressMarkers: true,
            draggable: false,
            polylineOptions: { strokeColor: '#AAA', zIndex: 1 },
        };
        this.renderOptionsDriver = {
            suppressMarkers: true,
            draggable: false,
            polylineOptions: { strokeColor: '#00f', zIndex: 2 },
        };
        this.show = true;
        this.waypoints = [];
        // when OnDestroy is called.
        this.data = [];
        this.legsSource = [];
        this.legsNewLegs = [];
        this.directions = null;
        this.markers = [];
        this.markersDriver = [];
        this.showMarkers = false;
        this.legsToDirection = [];
        this.dataSource = new MatTableDataSource();
        this.dataSourcePin = new MatTableDataSource();
        this.displayedColumns = ['pointStart', 'pointEnd', 'type', 'remove'];
        this.displayedColumnsPin = ['lat', 'lng', 'label'];
        this.haveDriver = false;
        this.showMap = true;
        this.icon = {
            url: './assets/images/red_truck.png',
            scaledSize: {
                height: 40,
                width: 40
            },
        };
        // relativos aos pontos do tracking
        this.colorPrefix = 'COLOR/';
        this.coloredPoint = [
            { scaledSize: { height: 5, width: 5 }, color: 'red', url: './assets/images/red_point.png' },
            { scaledSize: { height: 5, width: 5 }, color: 'blue', url: './assets/images/blue_point.png' },
            { scaledSize: { height: 5, width: 5 }, color: 'green', url: './assets/images/green_point.png' },
            { scaledSize: { height: 5, width: 5 }, color: 'pink', url: './assets/images/pink_point.png' },
            { scaledSize: { height: 5, width: 5 }, color: 'purple', url: './assets/images/purple_point.png' },
            { scaledSize: { height: 5, width: 5 }, color: 'orange', url: './assets/images/orange_point.png' }
        ];
        this.pickupAddress = 'R. Ambrósio Molina, 1090 - Eugênio de Melo, São José dos Campos - SP, 12247-000';
        // mdr.status para os quais considera-se que mdr foi finalizada
        this.finishedDriveStatus = ['Carga entregue com sucesso',
            'Carga retornada total',
            'Entrega de carga certificada pelo LSP',
            'MDR paga / concluída'
        ];
        // colunas para mostrar posições dos motoristas
        this.driverPositionTableColumns = [
            { value: 'createdAt', name: 'GEOLOCATION/table/time' },
            { value: 'lat', name: 'GEOLOCATION/table/lat' },
            { value: 'lng', name: 'GEOLOCATION/table/lng' },
            { value: 'speed', name: 'GEOLOCATION/table/speed' },
            { value: 'phoneNumber', name: 'GEOLOCATION/table/phone' },
            { value: 'color', name: 'GEOLOCATION/table/color' }
        ];
        this.markersTruck = [];
        this.alive = true;
    }
    GeolocationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.mdrObservable.currentMDR.subscribe(function (mdr) {
            _this.mdr = mdr;
            _this.getLegsDelete();
            _this.getDriverLastPosition();
        });
    };
    GeolocationComponent.prototype.ngOnChanges = function () {
        if (this.mdr.id) {
            this.getLegsDelete();
            this.getDriverLastPosition();
            this.getDriverPosition();
        }
    };
    GeolocationComponent.prototype.onResponse = function (event) {
        if (!event.routes[0]) {
            return;
        }
        // console.log(event);
        // this.distanceRemaining = event.routes[0].legs[0].distance.text;
        // this.timeRemaining = event.routes[0].legs[0].duration.text;
        this.legsNewLegs.forEach(function (leg) {
            if (Math.abs(leg.pointInit.lat - event.routes[0].legs[0].start_location.lat()) < 0.01 &&
                Math.abs(leg.pointInit.lng - event.routes[0].legs[0].start_location.lng()) < 0.01 &&
                Math.abs(leg.pointEnd.lat - event.routes[0].legs[0].end_location.lat()) < 0.01 &&
                Math.abs(leg.pointEnd.lng - event.routes[0].legs[0].end_location.lng()) < 0.01) {
                leg.distance = event.routes[0].legs[0].distance.value;
                leg.ETA = event.routes[0].legs[0].duration.value;
            }
        });
        this.updateETA();
    };
    GeolocationComponent.prototype.onResponseDriver = function (event) {
        if (!event.routes[0]) {
            return;
        }
        // console.log(event);
        var dist = event.routes[0].legs[0].distance.value;
        var ETA = event.routes[0].legs[0].duration.value;
        this.distanceRemaining = Math.floor(dist / 1000) + ' km';
        this.timeRemaining = Math.floor(ETA / 3600) + ' h e ' + Math.floor((ETA % 3600) / 60) + ' min';
    };
    GeolocationComponent.prototype.updateETA = function () {
        var dist = 0;
        var ETA = 0;
        this.legsNewLegs.forEach(function (leg) {
            if (leg.type === 'Rodoviário') {
                dist += leg.distance;
                ETA += leg.ETA;
            }
        });
        this.distanceRemaining = Math.floor(dist / 1000) + ' km';
        this.timeRemaining = Math.floor(ETA / 3600) + ' h e ' + Math.floor((ETA % 3600) / 60) + ' min';
    };
    GeolocationComponent.prototype.removeLeg = function (legToRemove) {
        var _this = this;
        var flag = -1;
        for (var i = 0; i < this.legsNewLegs.length; i++) {
            if (this.legsNewLegs[i] === legToRemove) {
                flag = i;
                // console.log(flag)
            }
        }
        this.mdrService.removeLeg(legToRemove, this.mdr.id).subscribe(function (response) {
            if (flag - 1 > -1 && flag + 1 < _this.legsNewLegs.length) {
                _this.legsNewLegs[flag - 1].pointEnd = legToRemove.pointEnd;
                _this.mdrService.putLegs(_this.legsNewLegs[flag - 1], _this.mdr.id).subscribe(function (data) {
                    _this.dataSource = new MatTableDataSource(_this.legsNewLegs);
                    _this.getLegsDelete();
                    _this.updateETA();
                });
                _this.legsNewLegs[flag + 1].pointInit = legToRemove.pointInit;
                _this.mdrService.putLegs(_this.legsNewLegs[flag - 1], _this.mdr.id).subscribe(function (data) {
                    _this.dataSource = new MatTableDataSource(_this.legsNewLegs);
                    _this.getLegsDelete();
                    _this.updateETA();
                });
            }
            _this.getLegsDelete();
            _this.updateETA();
        });
    };
    GeolocationComponent.prototype.deletePin = function () {
        var _this = this;
        // console.log('Remove:');
        // console.log(this.markerDelete);
        var flag = -1;
        for (var i = 0; i < this.markers.length; i++) {
            // console.log(this.markers[i].label);
            if (this.markers[i].label === this.markerDelete) {
                flag = i;
            }
        }
        // console.log(flag);
        // console.log(this.legsNewLegs);
        if (flag !== -1) {
            var markerInit = this.legsNewLegs[flag].pointInit;
            this.mdrService.removeLeg(this.legsNewLegs[flag], this.mdr.id).subscribe(function (data) {
                _this.getLegsDelete();
                _this.updateETA();
                _this.dataSource = new MatTableDataSource(_this.legsNewLegs);
            });
            if (flag - 1 > -1) {
                this.mdrService.removeLeg(this.legsNewLegs[flag - 1], this.mdr.id).subscribe(function (data) {
                    _this.getLegsDelete();
                    _this.updateETA();
                    _this.dataSource = new MatTableDataSource(_this.legsNewLegs);
                });
            }
        }
    };
    GeolocationComponent.prototype.addPin = function () {
        // console.log(this.latNew);
        // console.log(this.lngNew);
        // console.log(this.markers);
        if (this.latNew !== null && this.lngNew !== null) {
            this.markers.push({ lat: this.latNew, lng: this.lngNew, label: String.fromCharCode(this.markers.length + 65), title: '' });
            this.dataSourcePin = new MatTableDataSource(this.markers);
            this.snackBar.open('Ponto adicionado', 'Fechar', {
                duration: 2000,
            });
        }
    };
    GeolocationComponent.prototype.updateMarker = function (event, mark) {
        var _this = this;
        this.legsToDirection = [];
        this.markers.forEach(function (m) {
            if (m.label === mark.label) {
                m.lat = event.coords.lat;
                m.lng = event.coords.lng;
            }
        });
        this.legsNewLegs.forEach(function (leg) {
            if (leg.pointInit.label === mark.label) {
                leg.pointInit.lat = event.coords.lat;
                leg.pointInit.lng = event.coords.lng;
            }
            if (leg.pointEnd.label === mark.label) {
                leg.pointEnd.lat = event.coords.lat;
                leg.pointEnd.lng = event.coords.lng;
            }
            _this.legsToDirection.push(leg);
        });
        // console.log(this.legsNewLegs);
        // console.log(this.markers);
        this.saveRoute();
    };
    GeolocationComponent.prototype.createLeg = function () {
        // console.log('Version 1.0');
        var nLeg = new Legs();
        // console.log("error");
        // console.log(this.markerInit);
        for (var i = 0; i < this.markers.length; i++) {
            // console.log(this.markers[i]);
            if (this.markers[i].label === this.markerInit) {
                nLeg.pointInit = this.markers[i];
                if (this.legsNewLegs.length > i) {
                    nLeg.order = this.legsNewLegs[i].order + 1;
                }
            }
            else if (this.markers[i].label === this.markerEnd) {
                nLeg.pointEnd = this.markers[i];
                if (this.legsNewLegs.length > i) {
                    nLeg.order = this.legsNewLegs[i].order - 1;
                }
            }
        }
        if (nLeg.order === null) {
            nLeg.order = 0;
        }
        var letterEndtoEnd = this.legsNewLegs.filter(function (legs) { return (nLeg.pointEnd.lat === legs.pointEnd.lat && nLeg.pointEnd.lng === legs.pointEnd.lng); }).map(function (legs) { return legs.pointEnd.label; });
        var letterEndtoInit = this.legsNewLegs.filter(function (legs) { return (nLeg.pointEnd.lat === legs.pointInit.lat && nLeg.pointEnd.lng === legs.pointInit.lng); }).map(function (legs) { return legs.pointInit.label; });
        var letterInittoInit = this.legsNewLegs.filter(function (legs) { return (nLeg.pointInit.lat === legs.pointInit.lat && nLeg.pointInit.lat === legs.pointInit.lng); }).map(function (legs) { return legs.pointInit.label; });
        var letterInittoEnd = this.legsNewLegs.filter(function (legs) { return (nLeg.pointInit.lat === legs.pointEnd.lat && nLeg.pointInit.lat === legs.pointEnd.lng); }).map(function (legs) { return legs.pointEnd.label; });
        // console.log(letterEndtoEnd);
        // console.log(letterEndtoInit);
        // console.log(letterInittoInit);
        // console.log(letterInittoEnd);
        // console.log(nLeg);
        nLeg.type = this.selectedType;
        if (this.legsNewLegs.length === 0) {
            nLeg.type = this.selectedType;
            this.legsNewLegs.push(nLeg);
            // console.log(this.legsNewLegs);
            this.legsToDirection.push(nLeg);
            this.saveRoute();
        }
        else {
            if (nLeg.pointEnd.label === this.legsNewLegs[0].pointInit.label || nLeg.pointInit.label === this.legsNewLegs[this.legsNewLegs.length - 1].pointEnd.label) {
                this.legsNewLegs.push(nLeg);
                // console.log(this.legsNewLegs);
                this.legsToDirection.push(nLeg);
                this.saveRoute();
            }
            else {
                this.snackBar.open('Leg invalida', 'Fechar', {
                    duration: 2000,
                });
            }
        }
    };
    GeolocationComponent.prototype.removeDirection = function () {
        this.showMap = false;
    };
    GeolocationComponent.prototype.showDirection = function () {
        this.showMap = true;
    };
    GeolocationComponent.prototype.getLegs = function () {
        var _this = this;
        this.legsNewLegs = [];
        this.markers = [];
        if (this.legsNewLegs.length === 0) {
            this.mdrService.getLegs(this.mdr.id).subscribe(function (data) {
                // console.log(data);
                // console.log('legs');
                data.forEach(function (leg, i) {
                    // console.log(leg);
                    var legNew = new Legs();
                    legNew.id = leg.id;
                    var letterInittoInit = _this.legsNewLegs.filter(function (legs) { return (parseFloat(leg.pointInit.lat) === legs.pointInit.lat && parseFloat(leg.pointInit.lng) === legs.pointInit.lng); }).map(function (legs) { return legs.pointInit.label; });
                    var letterInittoEnd = _this.legsNewLegs.filter(function (legs) { return (parseFloat(leg.pointInit.lat) === legs.pointEnd.lat && parseFloat(leg.pointInit.lng) === legs.pointEnd.lng); }).map(function (legs) { return legs.pointEnd.label; });
                    var letterEndtoEnd = _this.legsNewLegs.filter(function (legs) { return (parseFloat(leg.pointEnd.lat) === legs.pointEnd.lat && parseFloat(leg.pointEnd.lng) === legs.pointEnd.lng); }).map(function (legs) { return legs.pointEnd.label; });
                    var letterEndtoInit = _this.legsNewLegs.filter(function (legs) { return (parseFloat(leg.pointEnd.lat) === legs.pointInit.lat && parseFloat(leg.pointEnd.lng) === legs.pointInit.lng); }).map(function (legs) { return legs.pointInit.label; });
                    // console.log('letter');
                    // console.log(this.legsNewLegs);
                    // console.log(leg);
                    // console.log(letterInittoInit);
                    // console.log(letterInittoEnd);
                    // console.log(letterEndtoEnd);
                    // console.log(letterEndtoInit);
                    if (letterInittoInit.length > 0) {
                        legNew.pointInit.lat = parseFloat(leg.pointInit.lat);
                        legNew.pointInit.lng = parseFloat(leg.pointInit.lng);
                        legNew.pointInit.label = letterInittoInit[0];
                    }
                    else if (letterInittoEnd.length === 0 && i !== 0) {
                        legNew.pointInit.lat = parseFloat(leg.pointInit.lat);
                        legNew.pointInit.lng = parseFloat(leg.pointInit.lng);
                        legNew.pointInit.label = String.fromCharCode(i + 1 + 65);
                        _this.markers.push({
                            lat: parseFloat(leg.pointInit.lat),
                            lng: parseFloat(leg.pointInit.lng),
                            label: String.fromCharCode(i + 1 + 65),
                            title: '',
                        });
                    }
                    else {
                        legNew.pointInit.lat = parseFloat(leg.pointInit.lat);
                        legNew.pointInit.lng = parseFloat(leg.pointInit.lng);
                        legNew.pointInit.label = String.fromCharCode(i + 65);
                    }
                    if (letterEndtoEnd.length > 0) {
                        legNew.pointEnd.lat = parseFloat(leg.pointEnd.lat);
                        legNew.pointEnd.lng = parseFloat(leg.pointEnd.lng);
                        legNew.pointEnd.label = letterEndtoEnd[0];
                    }
                    else if (letterEndtoInit.length > 0) {
                        legNew.pointEnd.lat = parseFloat(leg.pointEnd.lat);
                        legNew.pointEnd.lng = parseFloat(leg.pointEnd.lng);
                        legNew.pointEnd.label = letterEndtoInit[0];
                    }
                    else {
                        legNew.pointEnd.lat = parseFloat(leg.pointEnd.lat);
                        legNew.pointEnd.lng = parseFloat(leg.pointEnd.lng);
                        legNew.pointEnd.label = String.fromCharCode(i + 1 + 65);
                        _this.markers.push({
                            lat: parseFloat(leg.pointEnd.lat),
                            lng: parseFloat(leg.pointEnd.lng),
                            label: String.fromCharCode(i + 1 + 65),
                            title: '',
                        });
                    }
                    legNew.type = leg.type;
                    legNew.order = leg.order;
                    // console.log(leg.type);
                    _this.legsNewLegs.push(legNew);
                    // console.log("lala");
                    // console.log(this.markers);
                });
                // console.log('Markers and Legs:');
                // console.log(this.markers);
                // console.log(this.legsNewLegs);
            });
            this.showMarkers = true;
            this.updateETA();
            this.dataSource = new MatTableDataSource(this.legsNewLegs);
        }
    };
    GeolocationComponent.prototype.getLegsDelete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.mdrService.getLegs(this.mdr.id).subscribe(function (data) {
                            _this.legsNewLegs = [];
                            _this.markers = [];
                            data.forEach(function (leg, i) {
                                var legNew = new Legs();
                                legNew.id = leg.id;
                                var letterInittoInit = _this.legsNewLegs.filter(function (legs) {
                                    return (parseFloat(leg.pointInit.lat) === legs.pointInit.lat && parseFloat(leg.pointInit.lng) === legs.pointInit.lng);
                                }).map(function (legs) { return legs.pointInit.label; });
                                var letterInittoEnd = _this.legsNewLegs.filter(function (legs) {
                                    return (parseFloat(leg.pointInit.lat) === legs.pointEnd.lat && parseFloat(leg.pointInit.lng) === legs.pointEnd.lng);
                                }).map(function (legs) { return legs.pointEnd.label; });
                                var letterEndtoEnd = _this.legsNewLegs.filter(function (legs) {
                                    return (parseFloat(leg.pointEnd.lat) === legs.pointEnd.lat && parseFloat(leg.pointEnd.lng) === legs.pointEnd.lng);
                                }).map(function (legs) { return legs.pointEnd.label; });
                                var letterEndtoInit = _this.legsNewLegs.filter(function (legs) {
                                    return (parseFloat(leg.pointEnd.lat) === legs.pointInit.lat && parseFloat(leg.pointEnd.lng) === legs.pointInit.lng);
                                }).map(function (legs) { return legs.pointInit.label; });
                                // console.log('letter');
                                // console.log(this.legsNewLegs);
                                // console.log(leg);
                                // console.log(letterInittoInit);
                                // console.log(letterInittoEnd);
                                // console.log(letterEndtoEnd);
                                // console.log(letterEndtoInit);
                                if (i === 0) {
                                    // console.log("lala");
                                    _this.markers.push({
                                        lat: parseFloat(leg.pointInit.lat),
                                        lng: parseFloat(leg.pointInit.lng),
                                        label: 'A',
                                        title: '',
                                    });
                                }
                                if (letterInittoInit.length > 0) {
                                    legNew.pointInit.lat = parseFloat(leg.pointInit.lat);
                                    legNew.pointInit.lng = parseFloat(leg.pointInit.lng);
                                    legNew.pointInit.label = letterInittoInit[0];
                                }
                                else if (letterInittoEnd.length === 0 && i !== 0) {
                                    legNew.pointInit.lat = parseFloat(leg.pointInit.lat);
                                    legNew.pointInit.lng = parseFloat(leg.pointInit.lng);
                                    legNew.pointInit.label = String.fromCharCode(i + 1 + 65);
                                    _this.markers.push({
                                        lat: parseFloat(leg.pointInit.lat),
                                        lng: parseFloat(leg.pointInit.lng),
                                        label: String.fromCharCode(i + 1 + 65),
                                        title: '',
                                    });
                                }
                                else {
                                    legNew.pointInit.lat = parseFloat(leg.pointInit.lat);
                                    legNew.pointInit.lng = parseFloat(leg.pointInit.lng);
                                    legNew.pointInit.label = String.fromCharCode(i + 65);
                                }
                                if (letterEndtoEnd.length > 0) {
                                    legNew.pointEnd.lat = parseFloat(leg.pointEnd.lat);
                                    legNew.pointEnd.lng = parseFloat(leg.pointEnd.lng);
                                    legNew.pointEnd.label = letterEndtoEnd[0];
                                }
                                else if (letterEndtoInit.length > 0) {
                                    legNew.pointEnd.lat = parseFloat(leg.pointEnd.lat);
                                    legNew.pointEnd.lng = parseFloat(leg.pointEnd.lng);
                                    legNew.pointEnd.label = letterEndtoInit[0];
                                }
                                else {
                                    legNew.pointEnd.lat = parseFloat(leg.pointEnd.lat);
                                    legNew.pointEnd.lng = parseFloat(leg.pointEnd.lng);
                                    legNew.pointEnd.label = String.fromCharCode(i + 1 + 65);
                                    _this.markers.push({
                                        lat: parseFloat(leg.pointEnd.lat),
                                        lng: parseFloat(leg.pointEnd.lng),
                                        label: String.fromCharCode(i + 1 + 65),
                                        title: '',
                                    });
                                }
                                legNew.type = leg.type;
                                legNew.order = leg.order;
                                // console.log(leg.type);
                                _this.legsNewLegs.push(legNew);
                            });
                        });
                        this.showMarkers = true;
                        this.updateETA();
                        this.dataSource = new MatTableDataSource(this.legsNewLegs);
                        this.showMap = false;
                        return [4 /*yield*/, setTimeout(function () { _this.showMap = true; }, 1000)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GeolocationComponent.prototype.saveRoute = function () {
        var _this = this;
        var _loop_1 = function (i) {
            // console.log(this.legsNewLegs[i]);
            this_1.mdrService.putLegs(this_1.legsNewLegs[i], this_1.mdr.id).subscribe(function (data) {
                if (parseInt(i, 10) === _this.legsNewLegs.length - 1) {
                    // console.log('lal');
                    _this.getLegsDelete();
                    _this.updateETA();
                }
            });
        };
        var this_1 = this;
        for (var _i = 0, _a = Object.keys(this.legsNewLegs); _i < _a.length; _i++) {
            var i = _a[_i];
            _loop_1(i);
        }
        this.snackBar.open('Alterações Salvas', 'Fechar', {
            duration: 2000,
        });
    };
    // pega última posição da MDR
    GeolocationComponent.prototype.getDriverLastPosition = function () {
        var _this = this;
        // pega última posição da MDR
        this.mdrService.getDriverLastPosition(this.mdr).subscribe(function (elem) {
            if (elem !== undefined && !!elem) {
                _this.driverPosition = new Pin();
                _this.driverPosition.lat = parseFloat(elem.lat);
                _this.driverPosition.lng = parseFloat(elem.lng);
                _this.destination = new Pin();
                _this.haveDriver = true;
            }
        });
    };
    // pega posições do tracking
    GeolocationComponent.prototype.getDriverPosition = function () {
        var _this = this;
        this.markersTruck = [];
        this.mdrService.getDriverPosition(this.mdr.id).subscribe(function (driverList) {
            // monta lista de posições pra tabela e última posição do motorista
            _this.driverPositionList = [];
            driverList.forEach(function (driver, i) {
                // pra cada posição do motorista
                driver['positions'].forEach(function (position) {
                    // adiciona o telefone do motorista às posições
                    position['phoneNumber'] = driver['phoneNumber'];
                    // converte velocidade em km/h
                    position['speed'] = position['speed'] * 3.6;
                    // converte createdAt em Date
                    position['createdAt'] = new Date(position['createdAt']);
                    // escolhe cor para as posições
                    var colorI = i % _this.coloredPoint.length;
                    position['color'] = _this.colorPrefix + _this.coloredPoint[colorI].color;
                    position['icon'] = _this.coloredPoint[colorI];
                });
                // adiciona posições à lista de latlngs
                _this.driverPositionList = [].concat(_this.driverPositionList, driver['positions']);
            });
            // monta lista de markers pro mapa
            _this.driverPositionList.forEach(function (position) {
                _this.markersDriver.push({
                    lat: parseFloat(position['lat']),
                    lng: parseFloat(position['lng']),
                    label: '',
                    title: position['phoneNumber'],
                    icon: position['icon']
                });
            });
        });
    };
    return GeolocationComponent;
}());
export { GeolocationComponent };
var Position = /** @class */ (function () {
    function Position() {
        this.lat = null;
        this.lng = null;
    }
    return Position;
}());
export { Position };
var WayPoint = /** @class */ (function () {
    function WayPoint() {
        this.location = new Position();
        this.stopover = false;
    }
    return WayPoint;
}());
export { WayPoint };
